<module-container>
  <div class="title-container">
    <h2>Global Supplier Store Type</h2>
  </div>
  <abcis-table [configuration]="tableConfig">
    <app-store-supplier-selector></app-store-supplier-selector>
  </abcis-table>
</module-container>
